import { useEffect, useRef } from "react";
/**
 * Wraps a value with a ref which is updated when the value changes.
 * Useful when you need a stable reference to a value that changes.
 */
export function useRefWrap<T>(value: T): { current: T } {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
